import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

type Placement = 'header' | 'corner';

type Props = {
  /** `header`: inline with top bar (e.g. left of profile). `corner`: fixed top-right (login/oauth). */
  placement?: Placement;
};

/** iOS-style outline sun (dark mode → tap for light) and moon (light → tap for dark). */
function IconSun() {
  return (
    <svg className="theme-toggle-icon" viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
      <path
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
      />
    </svg>
  );
}

function IconMoon() {
  return (
    <svg className="theme-toggle-icon" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ThemeToggle: React.FC<Props> = ({ placement = 'header' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className={placement === 'corner' ? 'theme-toggle-corner' : 'theme-toggle-header'}
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark ? <IconSun /> : <IconMoon />}
    </button>
  );
};

export default ThemeToggle;
